<template>
  <div class="entity-analysis">
      <div class="text-container">
        <textarea id="demo-text-area" :class="textAreaClass" cols="64" rows="8" :disabled="disableTextArea"/>
        <div id="analysis-result"/>  
        <div class="key-container">
            <div id="key">
                <div id="red"></div> <p class="key-text">Person</p>
                <div id="green"></div><p class="key-text">Country, city, state</p>
                <div id="blue"></div><p class="key-text">Date, absolute or relative time period</p>
                <div id="yellow"></div><p class="key-text">Other identified text</p>
            </div>
        </div>
      </div>
    
  </div>
</template>

<script>
  //using Jquery in vue is gross but 'eh
  import $ from 'jquery';
  require('../lib/highlight-within-textarea.css');
  require('../lib/highlight-within-textarea.js');

  export default {
    name: 'EntityAnalysis',
    props: {
      showResults: Boolean,
      disableTextArea: Boolean,
      textAreaClass: { String, default: "show-border" }
    },
    mounted() {
      let vm = this;
      //Add event listener for keyup in the textArea
      $('#demo-text-area').keyup(function(event) {
          if (event.keyCode === 32) {//Space bar
              vm.analyseContentOfTextArea();
          }
      });
    },
    methods: {
      analyseContentOfTextArea: function(){
          var text = $('#demo-text-area').val();
          var model = 'en'; 
          var data = {text: text, model: model};

          fetch('https://www.lewismckeown.com:8095/ent',//process.env.SPACY_API_ENDPOINT,
                  {
                      method:'POST',
                      body: JSON.stringify(data)
                  })
                  .then(data=>{return data.json()})
                  .then(res=>{
                      this.printAnalysis(res);
                  })
                  .catch(error => console.log(error));
      },
      printAnalysis(results){
          $("#analysis-result").html('');
          var wordsToHighlight = [];
          results.forEach(res=>{wordsToHighlight.push(this.buildHighlightObject(res))});
          
          $("#demo-text-area").highlightWithinTextarea({
              highlight: wordsToHighlight
          });
          $("#demo-text-area").focus();//refocus after highlighting
          if(this.showResults){
            this.printResults(wordsToHighlight);
          }
      },
      printResults(wordsToHighlight){
        var resultsString = '';
        wordsToHighlight.forEach(res=>{resultsString+= '<P class="key-text">' + res.highlight + ' : ' + res.entityType})
          $("#analysis-result").html(resultsString);
      },buildHighlightObject(res){
          return {
              highlight: res.text,
              className: this.selectColour(res.type),
              entityType: this.getHumanReadableType(res.type)
          }
      },
      /**
       * Highlight identifiable information
       * Person - red
       * Location and Fac - blue (address related)
       * GPE - green (country slightly different address related)
       */
      selectColour(type){
          switch(type){
              case 'PERSON':
                  return 'red';
              case 'DATE':
                  return 'blue';
              case 'GPE':
                  return 'green';
              default:
                  return 'yellow';
          }
      },
      /**
       * Kind of absurd switch statement converting OntoNotes 5 types to human readable form
       */
      getHumanReadableType(type){
          switch(type) {
              case 'PERSON':
                  return 'Person';
              case 'FAC':
                  return 'Building, street, airport or similar';
              case 'ORG':
                  return 'Company or organisation';
              case 'GPE':
                  return 'Country, city, state';
              case 'LOC':
                  return 'Location';
              case 'PRODUCT':
                  return 'Object';
              case 'EVENT':
                  return 'Event';
              case 'WORK_OF_ART':
                  return 'Work of art';
              case 'LAW':
                  return 'Named document made into law';
              case 'LANGUAGE':
                  return 'Language';
              case 'DATE':
                  return 'Date or absolute or relative time period';
              case 'TIME':
                  return 'Time';
              case 'PERCENT':
                  return 'Percent';
              case 'MONEY':
                  return 'Currency or monetary value';
              case 'QUANTITY':
                  return 'Measurement (weight, distance etc)';
              case 'ORDINAL':
                  return 'Ordinal number (first, second etc)';
              case 'CARDINAL':
                  return 'Number';
              default:
                  return 'Unrecognised';
          }
      }

    }
  }
</script>